import { Component, Input } from "@angular/core";
import { FavouritesStorage, FavouritesStorageProvider } from "core-library/components/favourites/favourites-storage.service";

import { SearchResultItemModel } from "../../../models/search-result-item.model";

@Component({
    selector: "[pcg-ng-result-item]",
    templateUrl: "./result-item.component.html",
    providers: [FavouritesStorageProvider]
})
export class ResultItemComponent {
    @Input()
    public model: SearchResultItemModel = null;

    public constructor(
        private _favouritesStorage: FavouritesStorage
    ) {
    }

    public get isInBookmark(): boolean {
        return this._favouritesStorage.has(this.model.key);
    }

    public onToggleBookmark(): void {
        if (this.isInBookmark) {
            this._favouritesStorage.remove(this.model.key);
        } else {
            this._favouritesStorage.add(this.model.key);
        }
    }
}
